import { format } from 'date-fns'
import { TitledBlock } from 'components/Block'
import PaginationList from 'components/PaginationList'
import CommonList from './CommonList'
import { useTemporaryFeedbacks } from 'hooks/feedback'
import { Body } from 'components/styledFonts'

const TemporaryFeedbacks = () => {
    const { data } = useTemporaryFeedbacks()

    return (
        <TitledBlock
            title="フィードバック一時保存"
        >
            {data?.length > 0 ?
            <PaginationList
                max={3}
                gap={3}
                skipScroll
                data={data.map((d, i) => (
                    <CommonList
                        key={i}
                        title={d.タイトル}
                        mainPict={d.サムネイル}
                        client={d.企業名}
                        date={`締切日：${format(d.一時保存締切日, 'yyyy/MM/dd')}`}
                        to={`/feedback/input/${d.フィードバックNo}/${d.path}`}
                    />
                ))}
            />
            :
            <Body>一時保存中のフィードバックはありません</Body>
            }
        </TitledBlock>
    )
}

export default TemporaryFeedbacks
